module.exports = __webpack_public_path__ + "img/news-section-image03.3885559a.png";